import { useMutation } from '@tanstack/react-query'

import {
  type OnboardingInfo,
  type OnboardingInfoUpdateParams,
} from 'components/member_onboarding_v2/types'
import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'

export const useUpdateMemberOnboardingInfo = ({
  enrollmentEventId,
}: {
  enrollmentEventId: string;
}) => {
  return useMutation<
    OnboardingInfo,
    GrapeAPIErrorType,
    OnboardingInfoUpdateParams
  >({
    mutationFn: async (data: OnboardingInfoUpdateParams) => {
      const response = await fetchWithHeaders(
        `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/onboarding`,
        {
          method: 'PATCH',
          body: JSON.stringify(data),
        }
      )

      if (!response.ok) {
        const errors = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
          fieldErrors: errors.field_errors,
          requestId: response.headers.get('x-request-id') ?? undefined
        })
      }
      return response.json()
    },
  })
}
